/** Small tab-local receipt; never store the message text or replay the request. */
const PREFIX = 'claire-dispatched-turn:';
const entries = new Map<string, DispatchedTurn>();

export interface DispatchedTurn {
  at: number;
  previousUserMessages: number;
}

export function rememberDispatchedTurn(
  conversationId: string,
  previousUserMessages: number
): void {
  const receipt = { at: Date.now(), previousUserMessages };
  entries.set(conversationId, receipt);
  try {
    window.sessionStorage.setItem(
      PREFIX + conversationId,
      JSON.stringify(receipt)
    );
  } catch {
    // Same-page remounts still have the in-memory receipt.
  }
}

export function readDispatchedTurn(
  conversationId: string
): DispatchedTurn | null {
  try {
    const raw = window.sessionStorage.getItem(PREFIX + conversationId);
    if (raw) {
      const value = JSON.parse(raw);
      if (
        Number.isFinite(value.at) &&
        Number.isInteger(value.previousUserMessages) &&
        value.previousUserMessages >= 0
      )
        return value;
    }
  } catch {
    // Storage is optional.
  }
  return entries.get(conversationId) ?? null;
}

export function clearDispatchedTurn(conversationId: string): void {
  entries.delete(conversationId);
  try {
    window.sessionStorage.removeItem(PREFIX + conversationId);
  } catch {
    // Storage is optional.
  }
}
